import { createFileRoute } from "@tanstack/react-router";
import { Onboarding } from "@/components/Onboarding";
export const Route = createFileRoute("/onboarding/")({
  component: OnboardingPage,
  head: () => ({
    meta: [
      {
        title: "Onboarding | aiEmailAgent",
      },
      {
        name: "description",
        content: "Onboarding",
      },
    ],
  }),
});

export default function OnboardingPage() {
  return <Onboarding />;
}
